jQuery(document).ready(function ($) {
    'use strict';

    $('.gform_wrapper form').each(function () {
        $(this).removeAttr('novalidate');
    });

    let formelems = document.querySelectorAll('.gfield_contains_required input, .gfield_contains_required textarea, .gfield_contains_required select');
    formelems.forEach((formelem) => {
        formelem.required = true;
    });

    $('.captcha input').change(function () {
        if ( $(this).val() ) {
            $('.gform_button').prop('disabled', true);
        } else {
            $('.gform_button').prop('disabled', false);
        }
    });


});